import React, { FC, useMemo } from 'react';
import { UserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { ImpersonationContext, SourceContext } from '../lib/context';
import CriticalErrorComponent from './CriticalErrorComponent';

type Props = {
  children: React.ReactNode;
};

const UserContextBasicComponent: FC<Props> = ({ children }) => {
  const loggedInUser = window.userContext;
  const viewedUser = window.userContext.impersonatedUser || loggedInUser;
  const viewedUserGroups = viewedUser.memberOfGroups;
  const loggedInUserGroups = loggedInUser.memberOfGroups;
  const isApplicant = loggedInUserGroups.some((group) => group.name === 'BachelorAnsoeger');
  const isImpersonator = loggedInUserGroups.some((group) => group.name === 'BachelorImpersonator');
  const canViewedUserBeImpersonated = viewedUserGroups.some((group) => group.name === 'BachelorAnsoeger');
  const impersonation = useMemo(() => ({
    isApplicant,
    isImpersonator,
    canViewedUserBeImpersonated,
  }), [isApplicant, isImpersonator]);

  return (
    <CriticalErrorComponent>
      <UserContext.Provider value={viewedUser}>
        <SourceContext.Provider value={viewedUser.source as ISourceType}>
          <ImpersonationContext.Provider value={impersonation}>
            {children}
          </ImpersonationContext.Provider>
        </SourceContext.Provider>
      </UserContext.Provider>
    </CriticalErrorComponent>
  );
};

UserContextBasicComponent.displayName = 'UserContextBasicComponent';
export default UserContextBasicComponent;
